import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/auth.service';
import '../styles/SignInPage.css';
import { getErrorMessage } from '../utils/error';

const SignInPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.signIn({ email, password });
      navigate(
        authService.isOwner()
          ? '/dashboard'
          : authService.isAgency()
            ? '/agency/candidats'
            : '/tenant/dashboard'
      );
    } catch (err) {
      setError(getErrorMessage(err, 'Échec de connexion'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-card">
        <h1 className="signin-title">Coloc App</h1>
        <h2 className="signin-subtitle">Connexion</h2>
        
        {error && <div className="signin-error">{error}</div>}
        
        <form onSubmit={handleSubmit} className="signin-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              autoComplete="email"
              inputMode="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="form-control"
              placeholder="Entrez votre email"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-control"
              placeholder="Entrez votre mot de passe"
            />
          </div>
          
          <button 
            type="submit" 
            className="signin-button"
            disabled={loading}
          >
            {loading ? 'Connexion en cours...' : 'Se connecter'}
          </button>
        </form>
        <div className="signin-links">
          <Link to="/forgot-password" className="forgot-password-link">
            Mot de passe oublié ?
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
